<template name = "dateTemplate" lang="html">
		<!-- Create From -->
		<!-- Top bar-->
	<div class="row">
		<b-loading :is-full-page="isFullPage" :active.sync="isLoading" :can-cancel="true"></b-loading>
		<div id="header"></div>
		<div class="row">
			<div id="sidebarMenu" class="sidebar sidebar-fixed bg-white">
				<div class="sidebar-header">
					<h5>Search</h5>
					<a href="" id="sidebarMenuClose"><i data-feather="x"></i></a>
				</div><!-- df-sidebar-header -->
				<div class="sidebar-body"></div>
			</div><!-- sidebar-body -->
		</div><!-- sidebar -->
		<div class="content content-components">
			<div class="container pd-x-0 pd-lg-x-12 pd-xl-x-0 bs">  
				<div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
					<div>
						<nav aria-label="breadcrumb">
							<ol class="breadcrumb breadcrumb-style1 mg-b-10">
							<li class="breadcrumb-item">{{this.mainName}}</li>
							<li class="breadcrumb-item active" aria-current="page">{{this.subName}}</li>
							</ol>
							<h4 class="mg-b-0 tx-spacing--1">{{this.subName}}</h4>
						</nav>
					</div>
					<div class="d-none d-md-block">
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="createData()"><i data-feather="folder" class="wd-10 mg-r-5"></i>Save</button>
						<button class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5" v-on:click="goList()"><i data-feather="file" class="wd-10 mg-r-5"></i>list</button>
					</div>
				</div>
				<div class="mg-t-100 bs2">
					<div class="card ht-100p">
						<form action="form-validation.html" data-parsley-validate class="card-body list-group list-group-flush tx-13list-group list-group-flush tx-13 d-block">
							<div class="form-row col-md-5 d-block">
								<div class="form-group">
									<label for="input1">Pipeline Name <span class="tx-danger">*</span></label>
									<input type="text" v-model.trim="name" class="form-control" ref="name" id="name" placeholder="Pipeline Name">
								</div>
							</div>
							<div class="form-row col-md-5 d-block">
								<div class="form-group">
									<label for="input1">Pipeline Group <span class="tx-danger">*</span></label>
									 <b-select
                                        placeholder="Select a Pipeline"
                                        v-model="selTask" @change.native="selTaskHandler()">
                                        <option v-for="option in task" :value="option">
                                            {{ option.group }}
                                        </option>
                                    </b-select>
								</div>
							</div>
							<div class="form-row col-md-12 d-block">
								<div class="form-group">
									<label for="input4">Pipeline Execution Shell Script Path <span class="tx-danger">*</span></label>
									<input type="text" ref="path" v-model.trim="path" class="form-control" id="path" placeholder="Pipeline Execution Shell Script Path">
								</div>
							</div>

							<div class="form-row col-md-12 d-block">
								<div class="form-group">
									<label for="input4">Parameter</label><a href="" class="btn btn-xs pd-x-15 btn-secondary btn-uppercase mg-l-5 mg-sm-b-10-f" data-toggle="modal" data-animation="effect-flip-horizontal" @click="addParameter"><feather type="plus" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow"></feather>Add</a>
									<div v-for="(form, i) in param_array">
										<feather type="minus" @click="delParameter(i)" class="wd-15 hd-15 mg-r-5 valign-middle-f svg_overflow closed-cursor"></feather>
										<b-tooltip :label="form.message"
											position="is-bottom"
											:animated="false">
											<input type="text" :id="'key'+i" :value="form.key" @change="chgParameter(i,'key',$event)" placeholder="key" class="form-control d-inline w-auto">
										</b-tooltip>
										<b-tooltip :label="form.message"
											position="is-bottom"
											:animated="false">
											<input type="text" :id="'value'+i" :value="form.value" @change="chgParameter(i,'value',$event)" placeholder="value" class="form-control d-inline w-auto">
										</b-tooltip>
										<div class="field d-inline">
											<b-checkbox :id="'fixed'+i" true-value="true" false-value="false":value="form.fixed" @change.native="chgParameter(i,'fixed',$event)" type="is-info">Fixed</b-checkbox>
										</div>
									</div>
								</div>

							</div>
							<div class="modeRedering form-row float-left" v-if="this.saveMode=='update'">
								<div class="form-group">
									<label class="label-title">Status</label>
									<div class="input-group">
										<div class="ml-2 custom-control custom-radio mb-1">
											<input type="radio" v-model.trim="usedCode" name="usedcode" id="usedcode1" value="1" @change="chgUsedcode($event, '1')" class="custom-control-input">
											<label class="custom-control-label" for="usedcode1">Used</label>
										</div>
										<div class="ml-2 custom-control custom-radio mb-1">
											<input type="radio" v-model.trim="usedCode" name="usedcode" id="usedcode0" value="0" @change="chgUsedcode($event, '0')" class="custom-control-input form-check-input">
											<label class="custom-control-label" for="usedcode0">Unused</label>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div><!-- card -->
				</div>		
			</div>
		</div>
	</div>
</template>

<script>
	import Handsontable from 'handsontable';
	import {HotTable} from '@handsontable/vue';
	import 'handsontable-key-value';
	import common from '@/views/Common/common.js';

	//암호화
	import {secretKey} from '@/config/config';
	import crypto from 'crypto-js';

	import {bus} from '../../../main';

	export default {
		name: 'Detail',
		props: ['properties'],
		components: {
		HotTable
		},
		computed: {
			sheetSettings() {
				let settings = this.$store.getters.sheetSettings;
				return settings;
			},
			filteredDataArray() {;
				return this.data.filter((option) => {
					return option.toString().toLowerCase().indexOf(this.companyName.toLowerCase()) >= 0
				});
			}
		},
		data() {
			return {
				mainName: '',
				subName: '',
				menuData: [],
				saveMode: '',

				mid: '', 
				uid: '', 
				msid: '',
				ssid: '',
				userHeader:[],
				name: '',
				path: '',
				param_array: [],
				usedCode: '',
				flag: false,

				/* Loading */
				isLoading: false,
				isFullPage: true,

				data: [],
				selected: null,

				task:[],
				selTask:[],
			}
		},
		beforeDestroy(){
			bus.$off('menu_data');
		},
		created() {
			bus.$on('menu_data', (data)=>{
				this.menuData = data;
				this.modeFilter();
				this.classifyHeader();
			});

			this.uid = this.properties.uid;
			this.mid = this.properties.mid;

		},
		mounted() {
		
		},
		methods : {
			selTaskHandler() {
				this.param_array = [];
				this.path = this.selTask.path;
				for (let i in this.selTask.argument) {
					if (i > 1) {
						this.param_array.push({key: this.selTask.argument[i].ref,value:'', fixed: true, message:this.selTask.argument[i].description});
					}
				}
			},
			async classifyHeader() {
				let data = common.menuHeader(this.properties.mid, this.menuData, 3);
				this.mainName = data[0];
				this.subName  = data[1];
				this.msid = data[2];
				this.userHeader = data[3];

				const task = await this.$axios.get(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/task');
				this.task = task.data;
			},
			goList() {
				if (this.flag) {
					//등록, 수정 완료시 바로 리스트로 가기때문에 
				} else {
					const result = confirm("You didn't do anything. Would you like to go to the list?");
					if (result) this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.mid, type:'list'}});
					else return false;
				}
			},
			async modeFilter() { //create, update 구분 
				if (this.properties.uid) {//update
					this.saveMode = 'update';
				
					//update data가져오기
					await this.$axios.get(this.$apiHost + '/'+this.$route.name.replace('_detail','')+'/detail', {params:{'id':this.properties.uid}})
					.then(res => {
						for (let i in this.task) {
							if (this.task[i].id == res.data.groupId) {
								this.selTask = this.task[i]
							}
						}
						this.name = res.data.name;
						this.path = res.data.path;
						this.param_array = res.data.param;
						this.usedCode = res.data.usedCode;
					}).catch((error) => {});
				} else {//insert
					this.saveMode = 'insert';
				}
			},
			async createData() {
				if (!this.name) {
					alert('Please enter Pipeline Name.');
					this.$refs.name.focus();
					return false;

				} else if (!this.path) {
					alert('Please enter Pipeline Shell Script Path.');
					this.$refs.path.focus();
					return false;
				}
				if (confirm('Would you like to register?')) {
					const name = this.name;
					const path = this.path;
					const param = this.param_array;
					const usedCode = this.usedCode;
					const uid = this.uid;
					const msid = this.msid;
					const groupId = this.selTask.id;
					const params = common.isNull(usedCode) ? {uid, msid, name, path, param, groupId} : {uid, msid, name, path, param, usedCode, groupId};
					this.$axios.post(this.$apiHost + '/'+this.$route.name.substring(0, this.$route.name.indexOf('_')), params)
					.then((res) => {
						if (res.data.deduplication) {//중복
							alert(res.data.msg);
							this.userId = "";
							this.$refs.userId.focus();
						} else if (!res.data.deduplication) { //등록 완료
							var result = confirm('You have created user. Would you like to leave?');
							if (result) {
								this.$router.push({name:this.$route.name.replace('_detail',''), params:{mid:this.mid, type:'list'}});
							} else {
								return false;
							}
						}
					});

				}
			},
			addParameter() {
				this.param_array.push({key: '',value:'',message:'', fixed: false})
			},
			delParameter(row){
				this.param_array.splice(row, 1)
			},
			chgParameter(row, idx, $event){
				if(idx =='fixed') this.$set(this.param_array[row], idx, $event.target.checked)
				else this.$set(this.param_array[row], idx, $event.target.value)
			},
			chgUsedcode($event, idx){
				if(idx === 1) this.usedCode = 1;
				else this.usedCode = 0;
			}
		},
		watch: {
		},
	}
</script>
<style src="../../../../node_modules/handsontable/dist/handsontable.full.css"></style>
<style scoped>
	@import '../../../assets/css/buefy.css';
</style>


// WEBPACK FOOTER //
// src/views/Analysis/Pipeline/DetailForm.vue